// K6 — önceki yıla göre olağan dışı değer uyarısı (bloklamaz). Amber bilgi satırı;
// kaydı engellemez, `errorsByCode`'a girmez. Metin çağırandan gelir (tek kaynak kopyalar).

interface Props {
  text: string;
}

export function OutlierNotice({ text }: Props): JSX.Element {
  return (
    <div
      role="status"
      data-testid="outlier-notice"
      className="mt-1 rounded-md px-3 py-2 text-xs"
      style={{
        background: "var(--color-warning-bg)",
        color: "var(--color-warning-text)",
        border: "1px solid var(--color-warning-border)",
      }}
    >
      {text}
    </div>
  );
}
